export default __webpack_public_path__ + "static/media/windows-icon.da11a2dc.svg";